import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CompanyModel } from '../../../../shared/models/company.model';
import { FileService } from '../../../../shared/services/file.service';

/**
 * Success modal settings of a company (button label and content shown on reception, per language)
 */
@Component({
  selector: 'app-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.scss']
})
export class CmsComponent implements OnInit {

  @Input() form: FormGroup;

  readonly languages = ['en', 'de', 'fr', 'it'];
  readonly availableLocations = CompanyModel.availableSuccessModalLocations;

  selectedLanguage = this.languages[0];
  title: { [lang: string]: string } = {};
  body: { [lang: string]: string } = {};

  constructor(
    private fileService: FileService,
    private toast: ToastrService,
  ) { }

  ngOnInit(): void {
    this.title = { ...(this.form.get('successModalTitle').value ?? {}) };
    this.body = { ...(this.form.get('successModalBody').value ?? {}) };

    if (this.form.get('successModalLocation').value === null || this.form.get('successModalLocation').value === undefined) {
      this.form.get('successModalLocation').setValue(CompanyModel.MODAL_LOCATION_ALL);
    }
  }

  get isEnabled(): boolean {
    return !!this.form.get('hasSuccessModal').value;
  }

  updateTitle(value: string): void {
    this.title = { ...this.title, [this.selectedLanguage]: value };
    this.form.get('successModalTitle').setValue(this.title);
    this.form.get('successModalTitle').markAsDirty();
  }

  updateBody(value: string): void {
    this.body = { ...this.body, [this.selectedLanguage]: value };
    this.form.get('successModalBody').setValue(this.body);
    this.form.get('successModalBody').markAsDirty();
  }

  uploadImage = (file: File): Promise<string | undefined> => {
    return this.fileService.uploadImage(file, true).toPromise().then(uploadedFile => {
      const url = uploadedFile?.getImageUrl();
      if (!url) {
        this.toast.error('Image could not be uploaded. Only jpg, png, gif and webp images up to 5MB are allowed.');
      }
      return url;
    });
  }
}
